/*eslint no-loop-func: 0*/
/*eslint-env es6*/
import { fromJS, List, Map } from 'immutable';
import pip from '@turf/boolean-point-in-polygon';
import { multiPolygon, point, polygon } from '@turf/helpers';
import difference from '@turf/difference';
//import { multiPolygon, point, polygon, pip, difference } from 'turf';
import area from '@turf/area';

function compareMultipleWords(stringArray, commaDelimitedString) {
  var result = false;
  if(commaDelimitedString === null) {
    return result;
  } else {
    commaDelimitedString.split(', ').forEach(function(word) {
      if(stringArray.indexOf(word) > -1) {
        result = true;
      }
    })
    return result;
  }
}

// https://github.com/Turfjs/turf/issues/1583
function getDepth(arr) {
  const depths = []
  arr.forEach(x => {
    let depth = 0
    if (Array.isArray(x)) {
      depth = getDepth(x)
    }
    depths.push(depth)
  })
  return 1 + Math.max(...depths)
}

function margeArr(arr) {
  return arr.reduce((a, b) => {
    if (getDepth(b) > 2) {
      a.push(...b)
    } else {
      a.push(b)
    }
    return a
  }, [])
}

const getMulitPolygons = (polygons) => {
  let tempPolygons = [...polygons]
  let dep = getDepth(tempPolygons)
  if (dep < 2) {
    // min depth Two-dimensional array
    return
  }

  if (dep === 2) {
    tempPolygons = [tempPolygons]
  } else {
    while (dep > 3) {
      tempPolygons = margeArr(tempPolygons)
      dep = getDepth(tempPolygons)
    }
  }
  
  return tempPolygons
}


/* * * * * * * * * Hard-Coded list of Possible Carve-Outs * * * * * * * */
/*const carveOuts = [
  // Environmental
  {'id': 0, 'active': false, 'name': 'Puunene Mill & Surrounding Areas', 'tmks': ['Puunene Mill', 'Areas Surrounding Puunene Mill (Sump)', 'Areas Surrounding Puunene Mill (Dump)', 'McGerrow Camp Cesspool', 'Areas Surrounding Puunene Mill (Bone Yard)', 'Area Surrounding Puunene Mill (MOEQ and Spanish B Yards)', 'Areas Surrounding Puunene Mill (Camp Store)', 'Areas Surrounding Puunene Mill (Pump and Power)'], 'mod_tmks': ['38006020', '38006004', '38006013', '38006050', '38006011', '38006018', '38006051', '38006002', '38006001'], 'ex_tmks': ['38006012']},
  {'id': 1, 'active': false, 'name': 'Puunene Mill CADE Plant', 'tmks': ['Puunene CADE Plant'], 'mod_tmks': ['38006002'], 'ex_tmks': []},
  {'id': 2, 'active': false, 'name': 'Cinder Pit and Debris', 'tmks': ['Cinder Pit & Debris'], 'mod_tmks': ['38001007'], 'ex_tmks': []},
  {'id': 3, 'active': false, 'name': 'Maui Trap Club Shooting Range', 'tmks': ['Maui Trap Club Shooting Range'], 'mod_tmks': ['25003031'], 'ex_tmks': []},
  {'id': 4, 'active': false, 'name': 'Areas Surrounding Paia Mill', 'tmks': ['Areas Surrounding Paia Mill'], 'mod_tmks': ['25005019'], 'ex_tmks': []},
  {'id': 5, 'active': false, 'name': 'Mud Dump (Paia)', 'tmks': ['Mud Dump (Paia)'], 'mod_tmks': ['38003007', '38001006', '25003009'], 'ex_tmks': []},
  {'id': 6, 'active': false, 'name': 'Reservoir 32 CADE Station', 'tmks': ['Reservoir 32 CADE Station'], 'mod_tmks': ['25002002'], 'ex_tmks': []},
  {'id': 7, 'active': false, 'name': 'Field 602 CADE Station', 'tmks': ['Field 602 CADE Station'], 'mod_tmks': ['38001006'], 'ex_tmks': []},
  {'id': 8, 'active': false, 'name': 'Field 922 CADE Station', 'tmks': ['Field 922 CADE Station'], 'mod_tmks': ['38005002'], 'ex_tmks': []},
  {'id': 9, 'active': false, 'name': 'Concrete Flume in Rock Pile', 'tmks': ['Concrete Flume in Rock Pile'], 'mod_tmks': ['25002002'], 'ex_tmks': []},
  // Commercial
  {'id': 10, 'active': false, 'name': 'Hawaiian Cement Condominium', 'tmks': ['Hawaiian Cement Condominium Unit 1'], 'mod_tmks': ['38004001', '38004002'], 'ex_tmks': []},
  {'id': 11, 'active': false, 'name': 'Maalaea D&C Landfill Condominium', 'tmks': ['Maalaea D&C Landfill Condominium Unit 1'], 'mod_tmks': ['38005002'], 'ex_tmks': ['38005015']},
  {'id': 12, 'active': false, 'name': 'HC&D Condominium', 'tmks': ['HC&D Condominium Unit 1'], 'mod_tmks': ['38003004', '38003021', '38001001'], 'ex_tmks': []},
  {'id': 13, 'active': false, 'name': 'Paia Store Village Condominium', 'tmks': ['Paia Store Village Condominium Unit 1','Paia Store Village Condominium Unit 2','Paia Store Village Condominium Unit 4','Paia Store Village Condominium Unit 5'], 'mod_tmks': ['25005004', '25005009', '25005020', '25005012'], 'ex_tmks': ['25005052']}
]*/

/*const turfCarveOutsEnv = [
  // Environmental
  {'id': 0, 'active': false, 'area': 143, 'name': 'Puunene Mill', 'tmk': 'Puunene Mill', 'mod_tmks': ['38006004', '38006002', '38006001'], 'ex_tmks': ['38006020', '38006037', '38006009', '38006016', '38006051', '38006050', '38006011', '38006066', '38006013', '38006070', '38006018', '38006041'], fields: ['717'], list: "carveOutsEnv"},
  {'id': 1, 'active': false, 'area': 6.7, 'name': 'Puunene Mill CADE Plant', 'tmk': 'Puunene CADE Plant', 'mod_tmks': ['38006002'], 'ex_tmks': [], fields: ['707','717'], list: "carveOutsEnv"},
  {'id': 2, 'active': false, 'area': 1.2, 'name': 'Areas Surrounding Puunene Mill (Sump)', 'tmk': 'Areas Surrounding Puunene Mill (Sump)', 'mod_tmks': ['38006002'], 'ex_tmks': [], fields: ['717'], list: "carveOutsEnv"},
  {'id': 3, 'active': false, 'area': 295, 'name': 'Areas Surrounding Puunene Mill (Dump)', 'tmk': 'Areas Surrounding Puunene Mill (Dump)', 'mod_tmks': ['38006002', '38006001', '38003001'], 'ex_tmks': [], fields: ['704','707','708'], list: "carveOutsEnv"},
  {'id': 4, 'active': false, 'area': 0.5, 'name': 'Areas Surrounding Puunene Mill (Pump and Power)', 'tmk': 'Areas Surrounding Puunene Mill (Pump and Power)', 'mod_tmks': ['38006001'], 'ex_tmks': [], fields: ['706'], list: "carveOutsEnv"},
  {'id': 5, 'active': false, 'area': 11, 'name': 'Areas Surrounding Puunene Mill (Bone Yard)', 'tmk': 'Areas Surrounding Puunene Mill (Bone Yard)', 'mod_tmks': ['38006001'], 'ex_tmks': [], fields: ['706'], list: "carveOutsEnv"},
  {'id': 6, 'active': false, 'area': 20, 'name': 'Areas Surrounding Puunene Mill (MOEQ and Spanish B Yards)', 'tmk': 'Area Surrounding Puunene Mill (MOEQ and Spanish B Yards)', 'mod_tmks': ['38006001'], 'ex_tmks': [], fields: ['711'], list: "carveOutsEnv"},
  {'id': 7, 'active': false, 'area': 1.2, 'name': 'Areas Surrounding Puunene Mill (Camp Store)', 'tmk': 'Areas Surrounding Puunene Mill (Camp Store)', 'mod_tmks': ['38006002'], 'ex_tmks': ['38006012'], fields: ['707'], list: "carveOutsEnv"},
  {'id': 8, 'active': false, 'area': 1.0, 'name': 'McGerrow Camp Cesspool', 'tmk': 'McGerrow Camp Cesspool', 'mod_tmks': ['38006003'], 'ex_tmks': [], fields: ['714'], list: "carveOutsEnv"},
  {'id': 9, 'active': false, 'area': 16, 'name': 'Cinder Pit and Debris', 'tmk': 'Cinder Pit & Debris', 'mod_tmks': ['38001007'], 'ex_tmks': [], fields: ['611'], list: "carveOutsEnv"},
  {'id': 10, 'active': false, 'area': 20, 'name': 'Maui Trap Club Shooting Range', 'tmk': 'Maui Trap Club Shooting Range', 'mod_tmks': ['25003031'], 'ex_tmks': [], fields: ['300','303','312'], list: "carveOutsEnv"},
  {'id': 11, 'active': false, 'area': 10, 'name': 'Mud Dump (Paia)', 'tmk': 'Mud Dump (Paia)', 'mod_tmks': ['38003007', '38001006', '25003009'], 'ex_tmks': [], fields: ['206','209'], list: "carveOutsEnv"},
  {'id': 12, 'active': false, 'area': 0.4, 'name': 'Reservoir 32 CADE Station', 'tmk': 'Reservoir 32 CADE Station', 'mod_tmks': ['25002002'], 'ex_tmks': [], fields: ['304'], list: "carveOutsEnv"},
  {'id': 13, 'active': false, 'area': 3.0, 'name': 'Field 602 CADE Station', 'tmk': 'Field 602 CADE Station', 'mod_tmks': ['38001006'], 'ex_tmks': [], fields: ['602'], list: "carveOutsEnv"},
  {'id': 14, 'active': false, 'area': 1.0, 'name': 'Field 922 CADE Station', 'tmk': 'Field 922 CADE Station', 'mod_tmks': ['38005002'], 'ex_tmks': [], fields: ['922'], list: "carveOutsEnv"}
]
const turfCarveOutsComm = [
  // Commercial
  {'id': 0, 'active': false, 'area': 337, 'name': 'Hawaiian Cement Condominium', 'tmk': 'Hawaiian Cement Condominium Unit 1', 'mod_tmks': ['38004001', '38004002'], 'ex_tmks': ['810', '811', '819'], fields: [], list: "carveOutsComm"},
  {'id': 1, 'active': false, 'area': 18, 'name': 'Maalaea D&C Landfill Condominium', 'tmk': 'Maalaea D&C Landfill Condominium Unit 1', 'mod_tmks': ['38005002'], 'ex_tmks': ['38005015'], fields: ['906'], list: "carveOutsComm"},
  {'id': 2, 'active': false, 'area': 328, 'name': 'HC&D Condominium', 'tmk': 'HC&D Condominium Unit 1', 'mod_tmks': ['38003004', '38003021', '38001001'], 'ex_tmks': [], fields: ['505', '511'], list: "carveOutsComm"},
  {'id': 3, 'active': false, 'area': 5.3, 'name': 'Paia Store Village Condominium (Unit 1)', 'tmk': 'Paia Store Village Condominium Unit 1', 'mod_tmks': ['25005009', '25005020', '25005012'], 'ex_tmks': [], fields: ['207'], list: "carveOutsComm"},
  {'id': 4, 'active': false, 'area': 3.4, 'name': 'Paia Store Village Condominium (Unit 2)', 'tmk': 'Paia Store Village Condominium Unit 2', 'mod_tmks': ['25005004', '25005020'], 'ex_tmks': ['25005052'], fields: [], list: "carveOutsComm"},
  {'id': 5, 'active': false, 'area': 1.2, 'name': 'Paia Store Village Condominium (Unit 4)', 'tmk': 'Paia Store Village Condominium Unit 4', 'mod_tmks': ['25005020'], 'ex_tmks': [], fields: ['207'], list: "carveOutsComm"},
  {'id': 6, 'active': false, 'area': 1.2, 'name': 'Paia Store Village Condominium (Unit 5)', 'tmk': 'Paia Store Village Condominium Unit 5', 'mod_tmks': ['25005020'], 'ex_tmks': [], fields: ['204'], list: "carveOutsComm"},
  {'id': 7, 'active': false, 'area': 441, 'name': 'Kailua Plantation Condominium (Unit 1)', 'tmk': 'Kailua Plantation Condominium Unit 1', 'mod_tmks': ['25002001'], 'ex_tmks': [], fields: ['401'], list: "carveOutsComm"},
  {'id': 8, 'active': false, 'area': 3.1, 'name': 'MECO Parcel', 'tmk': 'MECO Parcel', 'mod_tmks': ['38006003'], 'ex_tmks': [], fields: ['719'], list: "carveOutsComm"}
]*/
const turfCprCarveOutsCpr = [
  // Finalized
  {'id': 0, 'active': false, 'area': 337, 'gisacres': 387.254, 'name': 'Hawaiian Cement Condominium', 'tmk': 'Hawaiian Cement Condominium Unit 1', 'mod_tmks': ['38004001', '38004002'], 'ex_tmks': [], fields: ['810', '811', '819'], list: "carveOutsCpr"},
  {'id': 1, 'active': false, 'area': 20,  'gisacres': 20.782, 'name': 'Maalaea D&C Landfill Condominium (Unit 1)', 'tmk': 'Maalaea D&C Landfill Condominium Unit 1', 'mod_tmks': ['38005002'], 'ex_tmks': [], fields: ['906'], list: "carveOutsCpr"},
  {'id': 2, 'active': false, 'area': 20,  'gisacres': 20.782, 'name': 'Maalaea D&C Landfill Condominium (Unit 4)', 'tmk': 'Maalaea D&C Landfill Condominium Unit 4', 'mod_tmks': ['38005002'], 'ex_tmks': [], fields: ['906'], list: "carveOutsCpr"},
  {'id': 3, 'active': false, 'area': 328, 'gisacres': 288.885, 'name': 'HC&D Condominium (Unit 1)', 'tmk': 'HC&D Condominium Unit 1', 'mod_tmks': ['38003004', '38003021', '38001001'], 'ex_tmks': [], fields: ['505', '511'], list: "carveOutsCpr"},
  {'id': 4, 'active': false, 'area': 328, 'gisacres': 288.885, 'name': 'HC&D Condominium (Unit 3)', 'tmk': 'HC&D Condominium Unit 3', 'mod_tmks': ['38003004', '38003021', '38001001'], 'ex_tmks': [], fields: ['505', '511'], list: "carveOutsCpr"},
  {'id': 5, 'active': false, 'area': 5.3, 'gisacres': 3.716, 'name': 'Paia Store Village Condominium (Unit 1A)', 'tmk': 'Paia Store Village Condominium Unit 1A', 'mod_tmks': ['25005009', '25005020', '25005012'], 'ex_tmks': [], fields: ['207'], list: "carveOutsCpr"},
  {'id': 6, 'active': false, 'area': 5.3, 'gisacres': 3.716, 'name': 'Paia Store Village Condominium (Unit 1B)', 'tmk': 'Paia Store Village Condominium Unit 1B', 'mod_tmks': ['25005009', '25005020', '25005012'], 'ex_tmks': [], fields: ['207'], list: "carveOutsCpr"},
  {'id': 7, 'active': false, 'area': 5.3, 'gisacres': 3.716, 'name': 'Paia Store Village Condominium (Unit 1C)', 'tmk': 'Paia Store Village Condominium Unit 1C', 'mod_tmks': ['25005009', '25005020', '25005012'], 'ex_tmks': [], fields: ['207'], list: "carveOutsCpr"},
  {'id': 8, 'active': false, 'area': 3.4, 'gisacres': 3.546, 'name': 'Paia Store Village Condominium (Unit 2)', 'tmk': 'Paia Store Village Condominium Unit 2', 'mod_tmks': ['25005004', '25005020'], 'ex_tmks': ['25005052'], fields: [], list: "carveOutsCpr"},
  {'id': 9, 'active': false, 'area': 1.2, 'gisacres': 1.748, 'name': 'Paia Store Village Condominium (Unit 4)', 'tmk': 'Paia Store Village Condominium Unit 4', 'mod_tmks': ['25005020'], 'ex_tmks': [], fields: ['207'], list: "carveOutsCpr"},
  {'id': 10, 'active': false, 'area': 1.2, 'gisacres': 1.497, 'name': 'Paia Store Village Condominium (Unit 5)', 'tmk': 'Paia Store Village Condominium Unit 5', 'mod_tmks': ['25005020'], 'ex_tmks': [], fields: ['204'], list: "carveOutsCpr"},
    // {'id': 7, 'active': true, 'area': 441, 'gisacres': 441.348, 'name': 'Kailua Plantation No. 1 Condominium (Unit 1)', 'tmk': 'Kailua Plantation No. 1 Condominium Unit 1', 'mod_tmks': ['25002001'], 'ex_tmks': [], fields: ['401'], list: "carveOutsCpr"},
  {'id': 11, 'active': false, 'area': 0.4, 'gisacres': 3.413, 'name': 'Kailua Plantation No. 2 Condominium (Unit 1)', 'tmk': 'Kailua Plantation No. 2 Condominium Unit 1 (Reservoir 32 CADE Station)', 'mod_tmks': ['25002002'], 'ex_tmks': [], fields: ['304'], list: "carveOutsCpr"},
  {'id': 12, 'active': false, 'area': 74,  'gisacres': 73.980, 'name': 'Puunene Mill Condominium (Unit 1)', 'tmk': 'Puunene Mill Condominium Unit 1', 'mod_tmks': ['38006001'], 'ex_tmks': [], fields: ['707'], list: "carveOutsCpr"},
    // {'id': 10, 'active': true, 'area': 269, 'gisacres': 255.783, 'name': 'Puunene Mill Condominium (Unit 2)', 'tmk': 'Puunene Mill Condominium Unit 2', 'mod_tmks': ['38006001'], 'ex_tmks': ['38006013', '38006018', '38006051', '38006016'], fields: ['707', '711'], list: "carveOutsCpr"},
  {'id': 13, 'active': false, 'area': 27, 'gisacres': 27.289, 'name': 'Puu Nene 2 Condominium (Unit 1)', 'tmk': 'Puu Nene 2 Condominium Unit 1 (Cinder Pit & Debris)', 'mod_tmks': ['38001007'], 'ex_tmks': [], fields: ['611'], list: "carveOutsCpr"},
  {'id': 14, 'active': false, 'area': 1.0, 'gisacres': 2.942, 'name': 'McGerrow Condominium (Unit 1)', 'tmk': 'McGerrow Condominium Unit 1 (McGerrow Camp Cesspool)', 'mod_tmks': ['38006003'], 'ex_tmks': [], fields: ['714'], list: "carveOutsCpr"},
  {'id': 15, 'active': false, 'area': 20, 'gisacres': 25.019, 'name': 'Trap and Gun Condominium (Unit 1)', 'tmk': 'Trap and Gun Condominium Unit 1 (Maui Trap Club Shooting Range)', 'mod_tmks': ['25003031'], 'ex_tmks': [], fields: ['300','303','312'], list: "carveOutsCpr"},
  {'id': 16, 'active': false, 'area': 10, 'gisacres': 11.469, 'name': 'West Sunny Side Condominium (Unit 1)', 'tmk': 'West Sunny Side Condominium Unit 1 (Mud Dump (Paia))', 'mod_tmks': ['38003007', '38001006', '25003009'], 'ex_tmks': [], fields: ['206','209'], list: "carveOutsCpr"},
  {'id': 17, 'active': false, 'area': 3.0, 'gisacres': 4.430, 'name': 'West Sunny Side Condominium (Unit 2)', 'tmk': 'West Sunny Side Condominium Unit 2 (Field 602 CADE Station)', 'mod_tmks': ['38001006'], 'ex_tmks': [], fields: ['602'], list: "carveOutsCpr"},
  {'id': 18, 'active': false, 'area': 119, 'gisacres': 124.290, 'name': 'Central Maui Baseyard Condominium (Unit 2)', 'tmk': 'Central Maui Baseyard Condominium Unit 2', 'mod_tmks': ['38005001'], 'ex_tmks': ['38005019', '38005022'], fields: ['900'], list: "carveOutsCpr"},
    // {'id': 17, 'active': true, 'area': 153, 'gisacres': 143.416, 'name': 'COEUS Condominium (Unit 1)', 'tmk': 'COEUS Condominium Unit 1', 'mod_tmks': ['38003002'], 'ex_tmks': [], fields: ['800', '806'], list: "carveOutsCpr"},
  {'id': 19, 'active': false, 'area': 26, 'gisacres': 25.211, 'name': 'Kaheka Condominium (Unit 1)', 'tmk': 'Kaheka Condominium Unit 1', 'mod_tmks': ['25005019','25005013'], 'ex_tmks': [], fields: ['213'], list: "carveOutsCpr"},
  {'id': 20, 'active': false, 'area': 17, 'gisacres': 16.761, 'name': 'Camp 5 Road Condominium (Unit 1)', 'tmk': 'Camp 5 Road Condominium Unit 1', 'mod_tmks': ['38006002'], 'ex_tmks': [], fields: ['717'], list: "carveOutsCpr"},
  {'id': 21, 'active': false, 'area': 189, 'gisacres': 182.946, 'name': 'Camp 5 Road Condominium (Unit 2)', 'tmk': 'Camp 5 Road Condominium Unit 2', 'mod_tmks': ['38006002'], 'ex_tmks': ['38006029', '38006015', '38006010'], fields: ['707', '708'], list: "carveOutsCpr"},
  {'id': 22, 'active': false, 'area': 189, 'gisacres': 182.946, 'name': 'Camp 5 Road Condominium (Unit 4)', 'tmk': 'Camp 5 Road Condominium Unit 4', 'mod_tmks': ['38006002'], 'ex_tmks': ['38006029', '38006015', '38006010'], fields: ['707', '708'], list: "carveOutsCpr"},
  {'id': 23, 'active': false, 'area': 8.8, 'gisacres': 387.254, 'name': 'Field 922 CADE Station', 'tmk': 'CADE Station', 'mod_tmks': ['38005002'], 'ex_tmks': [], fields: ['922'], list: "carveOutsCpr"},
  // Nursery lots no longer carve outs - purchased by Mahi Pono in 2021(?)
  /* {'id': 22, 'active': true, 'area': 3.6,  'gisacres': 3.642, 'name': 'Nursery', 'tmk': 'Nursery 1', 'mod_tmks': [], 'ex_tmks': ['38005031'], fields: [], list: "carveOutsCpr"},
  {'id': 23, 'active': true, 'area': 0.58, 'gisacres': 0.584, 'name': 'Nursery', 'tmk': 'Nursery 2', 'mod_tmks': [], 'ex_tmks': ['38005032'], fields: [], list: "carveOutsCpr"},
  {'id': 24, 'active': true, 'area': 3.9, 'gisacres': 3.8696, 'name': 'Nursery', 'tmk': 'Nursery 3', 'mod_tmks': [], 'ex_tmks': ['38005029'], fields: [], list: "carveOutsCpr"},
  {'id': 25, 'active': true, 'area': 17, 'gisacres': 17.506, 'name': 'Nursery', 'tmk': 'Nursery 4', 'mod_tmks': [], 'ex_tmks': ['38005021'], fields: [], list: "carveOutsCpr"},
  {'id': 26, 'active': true, 'area': 3.2, 'gisacres': 3.194, 'name': 'Nursery', 'tmk': 'Nursery 5', 'mod_tmks': [], 'ex_tmks': ['38005027'], fields: [], list: "carveOutsCpr"},
  {'id': 27, 'active': true, 'area': 2.8, 'gisacres': 2.778, 'name': 'Nursery', 'tmk': 'Nursery 6', 'mod_tmks': [], 'ex_tmks': ['38005028'], fields: [], list: "carveOutsCpr"} */
]

/* * * * * * * * * Adds all active carve-ous to the parcel data * * * * * * * */
const addCarveOutsToData = (state, action) => {
  //let activeCarveOuts = state.get('carveOutsEnv').filter(a => a.get('active')).concat(state.get('carveOutsComm').filter(b => b.get('active')))
  let activeCarveOuts = state.get('carveOutsCpr').filter(a => a.get('active'))
  let exes = activeCarveOuts.map(x => x.get('ex_tmks')).flatten().toSet().toList() // get rid of these from the data

  let carveOutData = activeCarveOuts.map((x, i) => fromJS({
    "id": state.get('data') + i, "tmk": x.get('tmk'), "parcel_type": null, "description": 'CPR Carve Out', "acres": x.get('area'),  "acres_portions": null, "acres_owned": null, "study_area":null, "ial": null, "hbu": null,
    "core": null, "sup": null, "notes": null, "base_acres": null, "market_value": null, "per_acre_value": null, "ial_value": null, "hbu_value": null, "core_value": null,  "sup_value": null, "include": 'CPR Carve Out',
    "acres_owned_adjacent": null, "value": null, "real_per_acre_value": null, "owner": null, "series": null, "has_portion": null, "is_core": null, "request_for_deregistration_submitted": null, "title_report_order": null,
    "date_of_report": null, "is_title_insurable": null, "is_ial": null, "parcel_notes": null, "hcs_fields": x.get('fields').join(', '), "details": null, "ab_risk_rank": null, "urban_carve_outs": null,
    "cty_tmk": x.get('tmk'), "m_risk_rank": null, "m_issues": null, "env_issues": null, "issues_ref_doc": null, "issues_details": null, "esi_issues_details": null, "esi_issues_notes": null, "canty_issues_details": null, "canty_issues_refs": null,
    "legal_entity": null, "gisacres": x.get('gisacres')
  }) )

  // remove TMKs excluded by active carve-out
  let data = state.get('data').filter(x => !exes.includes(x.get('cty_tmk')))

  // now add carveOutData to data
  let modifiedData = data.concat(carveOutData);

  return state.set('modifiedData', modifiedData);
}

/* * * * * * * * * Adds all active carve-outs to the parcel feature layer * * * * * * * */
const addCarveOutsToProperties = (state, action) => {
  //let activeCarveOuts = state.get('carveOutsEnv').filter(a => a.get('active')).concat(state.get('carveOutsComm').filter(b => b.get('active')))
  let activeCarveOuts = state.get('carveOutsCpr').filter(a => a.get('active'))
  let tmks = activeCarveOuts.map(x => x.get('tmk'))
  let mods = activeCarveOuts.map(x => x.get('mod_tmks')).flatten().toSet().toList()
  //let exes = activeCarveOuts.map(x => x.get('ex_tmks')).flatten().toSet().toList() // get rid of these from the properties

  let carveOutProperties = state.get('carveOutProperties').get('features').filter(x => tmks.includes(x.get('properties').get('Name'))).map(x =>
    fromJS({"type":"Feature", "properties": {"tmk": x.get('properties').get('Name'), "cty_tmk": x.get('properties').get('Name')}, "geometry": x.get('geometry').toJS()})
  )

  // get rid of parcels that are completely removed by a carve-out
  //let madProps = state.get('properties').get('features').filter(x => !exes.includes(x.get('properties').get('cty_tmk')))

  // modify TMKs with an active carve-out (clip)
  /*jshint loopfunc:true */
  var parcel, carve_outs, carve_out, new_areas = []; //, new_area;
  //var oom;
  let properties = state.get('properties').get('features').map(x => {
    if(mods.includes(x.get('properties').get('cty_tmk')) ) { // && x.get('properties').get('cty_tmk') === '38003004') {
      carve_outs = activeCarveOuts.filter(y => y.get('mod_tmks').includes(x.get('properties').get('cty_tmk'))).map(y => y.get('tmk')).toJS();
      if(x.get('geometry').get('type') === 'MultiPolygon') {
        parcel = multiPolygon(x.get('geometry').get('coordinates').toJS());
      } else {
        parcel = polygon(x.get('geometry').get('coordinates').toJS());
      }
      /*jshint loopfunc:true */
      for(var c = 0; c < carve_outs.length; c++) {
        //console.log(carve_outs[c])
        //console.log(state.get('carveOutProperties').get('features').filter(z => z.get('properties').get('Name') === carve_outs[c]).get(0).get('geometry').get('coordinates').toJS())
        carve_out = polygon(getMulitPolygons(state.get('carveOutProperties').get('features').filter(z => z.get('properties').get('Name') === carve_outs[c]).get(0).get('geometry').get('coordinates').toJS()));
        parcel = difference(parcel, carve_out);
      }
      new_areas.push({'cty_tmk': x.get('properties').get('cty_tmk'), 'gisacres': Math.round((area(parcel.geometry) * 0.000247105) * 1000) / 1000});  //update area (need to go into modifiedData for this?)
      return x.setIn(['geometry', 'coordinates'], fromJS(parcel['geometry']['coordinates'])).setIn(['geometry', 'type'], fromJS(parcel['geometry']['type']))
    } else {
      return x
    }
  })
  // now need to update gisacres for parcels that have been carved out
  var new_areas_tmks = new_areas.map(y => y.cty_tmk)
  let modifiedData = state.get('modifiedData').map(x => {
    if(new_areas_tmks.includes(x.get('cty_tmk')) ) {
      return x.set('gisacres', new_areas.filter(z => z.cty_tmk === x.get('cty_tmk'))[0]['gisacres'])
    } else {
      return x
    }
  })
  // now add carveOutProperties to properties
  let modifiedProperties = properties.concat(carveOutProperties);
  return state.setIn(['modifiedProperties', 'features'], modifiedProperties).set('modifiedData', modifiedData);
}


/* * * * * * * * * Apply Active Filters and Assign 'filteredData' * * * * * * * */
/* requires 'drawnPolygons' from MapApp and 'activeFilters' from FilterApp * * * */
const applyFilters = (state, action) => {
  var filteredData,
      activeFilters = action.activeFilters;

  var polygon = [];
  var polygons = [];
  if(action.drawnPolygons.size > 0) {
    activeFilters = activeFilters.set('polygons', Map({type: 'spatial'}));
    action.drawnPolygons.forEach(shape => {
      polygon = [];
      shape.get('coords').first().forEach(function(element, index, array) {
        polygon.push([element.lng, element.lat]) // I think the order of these changed when I updated to react-leaflet 1.5.1 ... ????
        //polygon.push([element.lat, element.lng])
      })
      polygons.push([polygon]);
    })
    var multiPoly = multiPolygon(polygons);
  }

  //var carveOutsOff = state.get('carveOuts').filter(x => !x.get('active')).map(x => x.get('tmks')).flatten();
  var pt;
  if(activeFilters.size){

    filteredData = state.get('modifiedData').filter( (data_point) => {

      var include = true;
      activeFilters.forEach( (activeFilter, field) => {
        switch(activeFilter.get('type')){
            //discrete filters are listed in an array, if our value isn't in the array, don't include it.
            case 'discrete':
              if(activeFilter.get('filters').indexOf(data_point.get(field)) === -1 && !(compareMultipleWords(activeFilter.get('filters').toJS(), data_point.get(field)))) {
                include = false;
              }
            break;

            //interval filters come with a min and max in an array. If our value is outside that array, don't include it.
            case 'interval':
            if(+data_point.get(field) > activeFilter.get('filters').get(0).max() || +data_point.get(field) < activeFilter.get('filters').get(0).min()){
                include = false;
              }
            break;

            case 'spatial':
               pt = point([+data_point.get('longitude'), +data_point.get('latitude')]) // I think the order of these changed when I updated to react-leaflet 1.5.1 ... ????
              //pt = point([+data_point.get('latitude'), +data_point.get('longitude')])
              if(!pip(pt, multiPoly)) {
                include = false;
              }
            break;

            default:
              include = true;
        }
      });

      // remove data_point if it is a carve out but is not turned on
      /*if(carveOutsOff.includes(data_point.get('cty_tmk'))) {
        include = false;
      }*/

      return include;
    })//.map( (data_point) => { return data_point.set('sample_date', moment(data_point.get('sample_date')).format('ll')) })

  } else { //if no active filters, show all data
    filteredData = state.get('modifiedData')//.map( (data_point) => { return data_point.set('sample_date', moment(data_point.get('sample_date')).format('ll')) })
  }
  return state.set('filteredData', filteredData)
}

// now filter properties based on data -- if TMK in filteredData.
const applyFilteredData = (state, action) => {
  var tmks = state.get('filteredData').map(x => x.get('cty_tmk'))

  var filteredProperties = state.get('modifiedProperties').get('features').map(x => {
    if(tmks.includes(x.get('properties').get('cty_tmk'))) {
      return x.set('visible', true).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('filteredData').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk')).get(0))
    } else {
      return x.set('visible', false).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk')).get(0))
    }
  })
  return state.set('filteredProperties', filteredProperties)
}

/*const applyFilteredData = (state, action) => { // this was when we were using carve outs in a different way (a pre-modified shapefile)
  var tmks = state.get('filteredData').map(x => x.get('cty_tmk'))
  var tmksMod = state.get('carveOuts').filter(x => x.get('active')).map(x => x.get('mod_tmks')).flatten()
  var tmksEx = state.get('carveOuts').filter(x => x.get('active')).map(x => x.get('ex_tmks')).flatten()
  var tmksCarve = state.get('carveOuts').filter(x => x.get('active')).map(x => x.get('tmks')).flatten()

  var filteredProperties = state.get('properties').get('features').map(x => {
    if(tmks.includes(x.get('properties').get('cty_tmk').replace('_mod', '')) && (tmksMod.includes(x.get('properties').get('cty_tmk').replace('_mod', '')) || tmksEx.includes(x.get('properties').get('cty_tmk').replace('_mod', '')) )) {
      if(x.get('properties').get('cty_tmk').includes('mod') && state.get('filteredData').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk').replace('_mod', '') && y.get('include').includes('Carve Out')).size) {
        return x.set('visible', true).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk').replace('_mod', '') && y.get('include').includes('Carve Out')).get(0))
      } else if(x.get('properties').get('cty_tmk').includes('mod') && state.get('filteredData').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk').replace('_mod', '') && !y.get('include').includes('Carve Out')).size) {
        return x.set('visible', false).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk').replace('_mod', '') && y.get('include').includes('Carve Out')).get(0))
      } else {
        return x.set('visible', false).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk') && !y.get('include').includes('Carve Out')).get(0))
      }
    } else if(tmks.includes(x.get('properties').get('cty_tmk')) && state.get('filteredData').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk').replace('_mod', '') && !y.get('include').includes('has')).size) {
      if(tmksCarve.includes(x.get('properties').get('cty_tmk'))) {
        return x.set('visible', true).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk')).get(0))
      } else {
        return x.set('visible', true).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk') && !y.get('include').includes('Carve Out')).get(0))
      }
    } else {
      return x.set('visible', false).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk')).get(0))
    }
  })
  return state.set('filteredProperties', filteredProperties)
}*/

/* * * * * * * * * Property Stats Calculator * * * * * * * * */
/*const calcStats = (data) => {
  return data.groupBy( (row) => row.get('property')).map((row, index) => {
    let results = row.map((row) => row.get('result') ? parseFloat(row.get('result')): null);
    let resultsNoNulls = results.filter((num) => num !== null);
    let resultsJS = results.toJS();
    let mean = d3.mean(resultsJS);
    let median = d3.median(resultsJS);
    let max = d3.max(resultsJS);
    let min = d3.min(resultsJS);
    return Map({min: min, max: max, mean: mean, median: median, sampleSize: resultsNoNulls.size});
  }).filter( (row) => row.get('max'));
}*/

/* * * * * * * * * Adding Stats to Properties & Filtering out Properties w/o Stats * * * * * * * * */
/*const calculateProperties = (state, action) => {
  // Calculate the stats
  var dataStats = calcStats(state.get('filteredData'))
  var latitudes = [],
      longitudes = [];
  // Attach dataStats above to properties, set visible=false if no stats for that property (i.e. no data)
  var filteredProperties = state.get('properties').map( (property) => {
    let stats = dataStats.get(property.get('property'))
    if(stats) {
      latitudes.push(parseFloat(property.get('latitude'), 10))
      longitudes.push(parseFloat(property.get('longitude'), 10))
      return property.set('visible', true).merge(stats)
    } else {
      return property.set('visible', false)
    }
  })
  var extent = List();
  // rough calculation of height and width of properties extent as a rectangle
  // based on https://en.wikipedia.org/wiki/Decimal_degrees - 90 m per 0.001 dd
  if(latitudes.length > 0) {
    var latitudeRange = d3.extent(latitudes.filter(x => x !== null))
    var longitudeRange = d3.extent(longitudes.filter(x => x !== null))
    var w = (latitudeRange[1] - latitudeRange[0]) * 90 // width in kilometers of data extent
    var l = (longitudeRange[1] - longitudeRange[0]) * 90 // length in kilometers of data extent
    extent = fromJS([w,l])
  }
  return state.set('filteredProperties', filteredProperties).set('filteredPropertiesDimensions', extent)
}*/


/* * * * * * * * * Set Filtered Property Selection Data for LocPlot * * * * * * * * */
/*const setSelectedPropertyResults = (state, action) => {
  let results = state.get('filteredData').filter((row) => row.get('property') === state.get('selectedProperty'))
    .map((row) => Map({'result':parseFloat(row.get('result')), 'date':row.get('sample_date'),  'detect': (['Nondetect'].indexOf(row.get('detect_status')) < 0 ? '' : '<')}))
    .sort((a,b) => {
      let aDate = moment(a.get('sample_date'), 'll').toDate()
      let bDate = moment(b.get('sample_date'), 'll').toDate()
      return aDate > bDate ? -1 : 1
  })
  return state.set('selectedPropertyResults', results);
}*/

/* * * * * * * * * Set Static Property Selection Data for LocPlot * * * * * * * * */
/*const setSelectedPropertyStaticResults = (state, action) => {
  let results = state.get('data').filter((row) =>
    row.get('property') === state.get('selectedProperty') && row.get('matrix') === action.matrix && row.get('unit') === action.unit
  ).map((row) => Map({'result':parseFloat(row.get('result')), 'date':row.get('sample_date'),  'detect': (['Nondetect'].indexOf(row.get('detect_status')) < 0 ? '' : '<')}))
      .sort((a,b) => {
        let aDate = moment(a.get('sample_date'), 'll').toDate()
        let bDate = moment(b.get('sample_date'), 'll').toDate()
        return aDate > bDate ? -1 : 1
      })
  return state.set('selectedPropertyStaticResults', results);
}*/

/* * * * * * * * * Highlight Properties * * * * * * * * */
const highlightProperties = (state, action) => {
  var highlightedProperties,
      selectedStat = action.radius === 'property' ? 'max' : action.radius,
      maxVal = state.get('filteredProperties').map((row) => row.get(selectedStat)).filter((row) => row !== null && row !== undefined).max();
  highlightedProperties = state.get('filteredProperties').map((row) => {
    let val = row.get(selectedStat)
    let inInterval = (val >= action.x0 && val < action.x1) || (val === action.x1 && val === maxVal);
    return row.set('highlight', inInterval)
  })
  return state.set('filteredProperties', highlightedProperties)
}

let initialState = Map({
  "data": List(),
  "modifiedData": List(),
  "properties": List(),
  "modifiedProperties": List(),
  "carveOutProperties": List(),
  "filteredData": List(),
  "filteredProperties": List(),
  "selectedProperty": null,
  "selectedPropertyResults": List(),
  //"carveOutsEnv": fromJS(turfCarveOutsEnv),
  //"carveOutsComm": fromJS(turfCarveOutsComm),
  "carveOutsCpr": fromJS(turfCprCarveOutsCpr)

});

const DataApp = (state = initialState, action) => {

  var newState = Map();

  switch(action.type){

    case "ERROR":
      return state.set('errorMessage', action.message)

    case "CLEAR_ERROR_MESSAGE":
      return state.set('errorMessage', null)

    case "RECEIVE_DATA":
      return state.set('data', fromJS(action.data.data))
        .set('modifiedData', fromJS(action.data.data))
        .set('properties', fromJS(JSON.parse(action.data.properties)))
        .set('modifiedProperties', fromJS(JSON.parse(action.data.properties)))
        .set('carveOutProperties', fromJS(JSON.parse(action.data.carveOuts)))
        .set('selectedProperty', null)
        .set('errorMessage', null)

    case "FILTER_DATA":
      let stateWithFilteredData = applyFilters(state, action)  // filters data and assigns 'filteredData' in state
      let stateWithFilteredProperties = applyFilteredData(stateWithFilteredData, action)
      return stateWithFilteredProperties

    case "CHOOSE_PROPERTY":
      if(state.get('selectedProperty') === action.property) {
        return state.set('selectedProperty', null)//.set('selectedPropertyResults', List())
      } else {
        return state.set('selectedProperty', action.property)
        //var stateWithSelectedProperty = state.set('selectedProperty', action.property)
        //return setSelectedPropertyResults(stateWithSelectedProperty, action);
      }

    case "INIT_CARVE_OUTS":
      return addCarveOutsToProperties(addCarveOutsToData(state, action), action)

    case "TOGGLE_CHECK_BOX":
      newState = state.setIn([action.list, action.id, 'active'], !state.get(action.list).get(action.id).get('active'));
      let stateWithCarveOutData = addCarveOutsToData(newState, action)
      let stateWithCarveOutProperties = addCarveOutsToProperties(stateWithCarveOutData, action)
      return stateWithCarveOutProperties

    case "CHOOSE_HISTOGRAM":
      var histogramSelection = action.x0 === state.get('histogramSelection') ? null : [action.x0, action.x1];
      if(histogramSelection !== null) {
        return highlightProperties(state, action);
      } else {
        return state.get('filteredProperties').map((row) => row.set('highlight', false))
      }

    case "CHOOSE_RADIUS":
      return state.set('filteredProperties', state.get('filteredProperties').map((row) => row.set('highlight', false)))


    default:
      return state
  }
}

export default DataApp;



// WEBPACK FOOTER //
// ./src/reducers/data.js